import React, {useEffect, useState} from "react";
import {ethers} from "ethers";
import {Button, Modal, Toast} from "react-bootstrap";
import {
    sttoreContractAbi, sttoreContractAddress,
    switchToArbitrum, sttoreDistributeContractAddress, sttoreDistributeContractAbi
} from "../../helpers/contracts";

function Sttore(props) {
    const [toastText, setToastText] = useState('')
    const [toastErrorShow, setToastErrorShow] = useState(false)
    const [toastCompleteShow, setToastCompleteShow] = useState(false)
    const [showWwModal, setWwModal] = useState(false)
    const [sttoreBalance, setSttoreBalance] = useState(0)
    const [pendingSTT, setPendingSTT] = useState(0)
    const [minSTTORE, setMinSttore] = useState(0)
    const [allowedToDistribute, setAllowToDistribute] = useState(false)

    const handleClaim = () => {
        if (window.ethereum) {
            window.ethereum.request({method: "eth_chainId"}).then((result) => {
                if (parseInt(result) === 42161) {
                    const provider_balance = new ethers.BrowserProvider(window.ethereum)
                    provider_balance.listAccounts().then(async (result) => {
                        const signer = await provider_balance.getSigner()
                        const sttoreContract = new ethers.Contract(sttoreContractAddress, sttoreContractAbi, signer)
                        sttoreContract.claimSTT().then(() => {
                            setTimeout(() => {
                                setToastCompleteShow(true)
                            }, 100)
                        }).catch((error) => {
                            setToastText(error.reason)
                            setToastErrorShow(true)
                        });
                    })
                } else {
                    switchToArbitrum()
                }
            })
        }
    }

    const handleDistribute = () => {
        if (window.ethereum) {
            window.ethereum.request({method: "eth_chainId"}).then((result) => {
                if (parseInt(result) === 42161) {
                    const provider_balance = new ethers.BrowserProvider(window.ethereum)
                    provider_balance.listAccounts().then(async (result) => {
                        const signer = await provider_balance.getSigner()
                        const sttoreDistributeContract = new ethers.Contract(sttoreDistributeContractAddress, sttoreDistributeContractAbi, signer)
                        sttoreDistributeContract.distribute().then(() => {
                            setTimeout(() => {
                                setToastCompleteShow(true)
                            }, 100)
                        }).catch((error) => {
                            setToastText(error.reason)
                            setToastErrorShow(true)
                        });
                    })
                } else {
                    switchToArbitrum()
                }
            })
        }
    }

    useEffect(() => {
        if (props.account) {
            const acc = props.account
            const provider_balance = new ethers.BrowserProvider(window.ethereum)
            const marketContract = new ethers.Contract(sttoreContractAddress, sttoreContractAbi, provider_balance)
            const distributeContract = new ethers.Contract(sttoreDistributeContractAddress, sttoreDistributeContractAbi, provider_balance)
            marketContract.balanceOf(acc).then((res) => {
                setSttoreBalance((parseInt(res) / 10 ** 9).toFixed(2))
            })
            marketContract.pendingSTT(acc).then((res) => {
                setPendingSTT(parseInt(res) / 10 ** 9)
            })
            marketContract.minSTTORE().then((res) => {
                setMinSttore(parseInt(res) / 10 ** 9)
            })
            distributeContract.canDistribute().then((res) => {
                if (res[0] === true) {
                    setAllowToDistribute(true)
                }
            })
        }
    }, []);

    return (
        <React.Fragment>
            <div className={"main-block eth-card"} style={{
                backgroundColor: '#FDE7BB',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}>
                <div className={"main-block__header"}>
                    <div>MY NETWORK BALANCE<span
                        style={{color: '#000', display: "block"}}>{sttoreBalance} STTORE</span>
                    </div>
                    <a href={'https://arbiscan.io/token/0x5cc7ef707a3f3a3eceac8c0546793c0428f1cca2'} target={'_blank'}
                       rel={'noopener noreferrer'}><img src={"/img/arrow-grey.png"} alt={''} style={{width: 35}}/></a>
                </div>
                {sttoreBalance <= 0
                    ? <React.Fragment>
                        <div className={""}>
                            <p style={{fontSize: 16, color: '#FE7144'}}>Network Bonus in STT is
                                claimable<br/>
                                only if your balance reaches<br/> {minSTTORE} STTORE tokens.</p>
                        </div>
                        <div></div>
                    </React.Fragment>
                    : <React.Fragment>
                        <div>
                            <p style={{
                                fontSize: '2.3rem',
                                fontWeight: 600,
                                color: '#FE7144',
                                fontFamily: '"Barlow Condensed", sans-serif',
                                textAlign: 'center',
                                marginBottom: 0
                            }}>{pendingSTT.toFixed(2)} STT</p>
                            <p style={{
                                color: '#000',
                                fontSize: 10,
                                textAlign: "center",
                                fontFamily: 'Ubuntu, sans-serif'
                            }}>Available to claim</p>
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}>
                            <div className={"additional-balances"}
                                 style={{width: '50%', marginTop: 0, fontSize: 11, color: '#888', fontWeight: 600}}>
                                ~ 0.00001 ETH<br/>
                                gas Fee
                            </div>
                            <>
                            {allowedToDistribute && (
                              <div className={"swap__confirm-button"} onClick={handleDistribute} style={{backgroundColor: '#aaaaaa33', color: '#FE7144', fontSize: '36px', width: 'auto', padding: 8, borderRadius: '50%', marginRight: 10}}>
                                  <i className="fa-light fa-refresh"></i>
                              </div>
                            )}
                            <Button className="modal-button" style={{
                                width: 150,
                                height: 70,
                                borderRadius: 35,
                                fontWeight: 600,
                                backgroundColor: "#FEB66690",
                                color: "#FE7144",
                                borderColor: "transparent",
                            }} disabled={sttoreBalance < minSTTORE} onClick={() => handleClaim()}>Claim</Button>
                            </>
                        </div>
                    </React.Fragment>
                }


            </div>


            <Toast onClose={() => window.location.reload()} show={toastCompleteShow}
                   onClick={() => setToastCompleteShow(false)} autohide delay={5000} position={"middle-center"}
                   className={"complete-toast"}>
                <Toast.Body>
                    <i className="fa-solid fa-circle-check"
                       style={{fontSize: '6rem', margin: 20, color: '#96fac5'}}></i>
                    <p style={{fontWeight: 600}}>SUCCESS</p>
                    <p className={"complete-toast-text"}>Please, refresh the page</p>
                </Toast.Body>
            </Toast>
            <Toast onClose={() => setToastErrorShow(false)} show={toastErrorShow}
                   onClick={() => setToastErrorShow(false)} autohide delay={5000} position={"middle-center"}
                   className={"complete-toast"}>
                <Toast.Body>
                    <i className="fa-solid fa-circle-xmark"
                       style={{fontSize: '6rem', margin: 20, color: '#ff968f'}}></i>
                    <p className={"toast-err"} style={{fontWeight: 600, color: '#dc3545'}}>ERROR</p>
                    <p className={"complete-toast-text"}>{toastText}</p>
                </Toast.Body>
            </Toast>
            <Modal size="sm" show={showWwModal} onHide={() => setWwModal(false)} aria-labelledby="info-mod-title"
                   className={"pre-form-modal telegram-modal"} centered>
                <Modal.Body>
                    <div className={"stt_modal_header"}>

                    </div>
                    <div className={"help-wrapper telegram-wrapper"} style={{paddingLeft: 0, paddingRight: 0}}>
                        <img src={"/img/lock.png"} alt={''} style={{width: 80, marginTop: 70}}/>
                        <p style={{
                            fontSize: '1.1rem',
                            marginBottom: 20,
                            marginTop: 30,
                            color: '#888888'
                        }}>Authorization</p>
                        <p style={{fontSize: '.8rem', marginTop: 0, fontWeight: 400, marginBottom: 25}}>To use full
                            functionality, login to the<br/>website with the browser of your crypto<br/>wallet</p>
                        <a href={"/login.pdf"} target={"_blank"} rel={"noreferrer"} style={{
                            fontSize: '.8rem',
                            marginTop: 0,
                            fontWeight: 500,
                            display: "block",
                            marginBottom: 45,
                            color: '#47c999'
                        }}>Instructions</a>

                        <Button className="modal-button" onClick={() => setWwModal(false)}>Ok</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default Sttore